module.exports = __webpack_public_path__ + "static/profile-442048a45daff55c803adc4e52223148.png";